@if (preferredCities() && preferredCities()!.length > 0) {
  <div class="space-y-3">
    <div class="flex items-center justify-between">
      <span class="text-xs text-neutral-10 font-medium">
        {{ preferredCities()!.length }} / 5 communes suivies
      </span>
      <span class="text-xs font-semibold text-primary-11 flex items-center gap-1">
        <mat-icon class="!w-3.5 !h-3.5 !text-xs">bolt</mat-icon>
        Alertes email en temps réel
      </span>
    </div>

    <div class="flex flex-wrap gap-2.5">
      @for (city of preferredCities()!; track city.name + '-' + city.zipCode) {
        <div
          class="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-xl text-xs font-bold bg-white dark:bg-neutral-2 text-neutral-12 border border-neutral-3 dark:border-neutral-4 shadow-xs hover:border-neutral-4 dark:hover:border-neutral-5 transition-colors"
        >
          <div
            class="w-6 h-6 rounded-lg bg-primary-2 text-primary-11 flex items-center justify-center shrink-0"
          >
            <mat-icon class="!w-3.5 !h-3.5 !text-sm">mark_email_unread</mat-icon>
          </div>
          <span>{{ city.name }}</span>
          <span class="font-mono text-neutral-10 text-[11px]">({{ city.zipCode }})</span>
        </div>
      }
    </div>
  </div>
} @else {
  <div
    class="p-6 text-center border-2 border-dashed border-neutral-3 dark:border-neutral-4 rounded-2xl bg-white dark:bg-neutral-2 shadow-xs"
  >
    <p class="text-xs text-neutral-9 italic">Aucune commune prioritaire configurée pour les alertes.</p>
  </div>
}
